import React, {Component} from 'react'
import {
  Box,
  Button,
  Grid,
  TextField,
  Typography,
  Snackbar,
  Collapse,
  Alert,
  AlertTitle,
  InputAdornment,
  IconButton,
  CircularProgress,
} from '@mui/material';
import PersonOutlineRoundedIcon from '@mui/icons-material/PersonOutlineRounded';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded';
import VisibilityOffRoundedIcon from '@mui/icons-material/VisibilityOffRounded';
import LoginRoundedIcon from '@mui/icons-material/LoginRounded';
import { withTranslation } from 'react-i18next';

import '../login/LoginPageStyles.css';

const session = require('../../config/session')
const RestTunel = require('../../libs/rest_tunnel')
const url = window.location.href;
const parts = url.split('/')
const entityName = parts[parts.length -1]

let hoy = new Date();
let año = hoy.getFullYear();

const inputSx = {
  borderRadius: '12px',
  backgroundColor: 'var(--input-bg)',
  transition: 'box-shadow 200ms ease, background-color 200ms ease',
  '& .MuiOutlinedInput-notchedOutline': {
    border: '1px solid var(--input-border)',
    transition: 'border-color 200ms ease',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: 'rgba(106, 158, 44, 0.4)',
  },
  '&.Mui-focused': {
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    boxShadow: '0 0 0 4px rgba(106, 158, 44, 0.15)',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: 'var(--clr) !important',
    borderWidth: '1px !important',
  },
  '& input': {
    padding: '14px 14px',
  },
}

class LoginPage extends Component {
  constructor(props) {
    super(props)

    this.tagEntidad = ""

    this.state = {
      entidad: null,
      mensajeError: "",
      mostrarAlerta: false,
      mensajeAlerta: '',
      severidadAlerta: 'error',
      showPassword: false,
      loading: false,
    }

    if(props.match && props.match.params.tag) {
      this.tagEntidad = props.match.params.tag
    }

    this.login = this.login.bind(this)

    this.txtUser = React.createRef()
    this.txtPassword = React.createRef()
  }

  showAlert = (mensaje, severidad = 'error') => {
    this.setState({
        mostrarAlerta: true,
        mensajeAlerta: mensaje,
        severidadAlerta: severidad,
    });
  }

  handleCloseAlert = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({ mostrarAlerta: false })
  }

  toggleShowPassword = () => {
    this.setState((prev) => ({ showPassword: !prev.showPassword }))
  }

  componentDidMount() {
    session.endSession()
    this.queryEntidad()
  }

  queryEntidad() {
    var restArgs = {
      method: 'POST',
      headers: 'JSON',
      body: {tag_entidad: this.tagEntidad},
      url: process.env.REACT_APP_URL_BACKEND + '/login/tag'
    }

    RestTunel.makePetition(restArgs,(err, data) => {
      if(err) {
        this.showAlert('Error consultando entidad', 'error')
        this.setState({
          entidad: null
        })
      } else {
        this.setState({
          entidad: data
        })
      }
    })
  }

  login = () => {
    const user = this.txtUser.current.value;
    const password = this.txtPassword.current.value;

    if (!user || !password) {
      this.showAlert('Por favor ingrese usuario y contraseña', 'warning');
      return;
    }

    this.setState({ loading: true })

    var restArgs = {
      method: 'POST',
      headers: 'JSON',
      body: {
        id_entidad: this.state.entidad.id,
        usuario: user,
        password: password
      },
      url: process.env.REACT_APP_URL_BACKEND + '/login/'
    }

    RestTunel.makePetition(restArgs, (err, data) => {
      if (err) {
        this.setState({ loading: false })
        this.showAlert(data?.message || 'Error en el login', 'error');
      } else {
        session.startSession(data.session);
        this.props.history.push('/dashboard');
      }
    });
  }

  render() {
    const { showPassword, loading } = this.state

    const welcomeBox = () => {
      return (
        <Grid item container xs={8}>
        </Grid>
      )
    }

    const loginBox = () => {
      return (
        <div
          className="login-container"
          style={{ backgroundImage: 'url("/Pegasus0.png")' }}
        >
          <div className="login-content">
            <Box
              component="form"
              className="login-card"
              noValidate
              autoComplete="off"
              onSubmit={(e) => {
                e.preventDefault();
                this.login();
              }}
            >
              <div className="logo-wrapper">
                <img alt='logo' src={`/entidades/${entityName}.png`} />
              </div>

              <div className="welcome-text">
                <h1>Bienvenido</h1>
                <p>Ingresa tus credenciales para continuar</p>
              </div>

              <div className="form">
                <Box className="input-span">
                  <label htmlFor="user" className="label">Usuario</label>
                  <TextField
                    type="text"
                    name="user"
                    id="user"
                    variant="outlined"
                    fullWidth
                    placeholder="Ingresa tu usuario"
                    inputRef={this.txtUser}
                    InputProps={{
                      sx: inputSx,
                      startAdornment: (
                        <InputAdornment position="start">
                          <PersonOutlineRoundedIcon sx={{ color: 'var(--clr)' }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>

                <Box className="input-span">
                  <label htmlFor="password" className="label">Contraseña</label>
                  <TextField
                    type={showPassword ? 'text' : 'password'}
                    name="password"
                    id="password"
                    variant="outlined"
                    fullWidth
                    placeholder="••••••••"
                    inputRef={this.txtPassword}
                    InputProps={{
                      sx: inputSx,
                      startAdornment: (
                        <InputAdornment position="start">
                          <LockOutlinedIcon sx={{ color: 'var(--clr)' }} />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={this.toggleShowPassword}
                            edge="end"
                            size="small"
                            aria-label="mostrar contraseña"
                            sx={{ color: '#7a7a7a' }}
                          >
                            {showPassword ? <VisibilityOffRoundedIcon /> : <VisibilityRoundedIcon />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>

                <Button
                  type="submit"
                  disableElevation
                  disabled={loading}
                  className="btn-login"
                  startIcon={
                    loading
                      ? <CircularProgress size={18} sx={{ color: '#fff' }} />
                      : <LoginRoundedIcon />
                  }
                  sx={{
                    mt: 1,
                    background: 'linear-gradient(135deg, var(--clr) 0%, var(--clr-hover) 100%) !important',
                    color: '#fff !important',
                    textTransform: 'uppercase',
                    fontWeight: 700,
                    letterSpacing: '0.06em',
                    fontSize: '0.95rem',
                    py: '0.85rem',
                    borderRadius: '14px',
                    boxShadow: '0 8px 20px rgba(106, 158, 44, 0.35)',
                    '&:hover': {
                      filter: 'brightness(1.05)',
                      boxShadow: '0 12px 24px rgba(106, 158, 44, 0.45)',
                    },
                    '&.Mui-disabled': {
                      color: '#fff !important',
                      opacity: 0.75,
                    },
                  }}
                >
                  {loading ? 'Ingresando…' : 'Ingresar'}
                </Button>
              </div>

              <Snackbar
                open={this.state.mostrarAlerta}
                onClose={this.handleCloseAlert}
                autoHideDuration={3000}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
              >
                <Collapse in={this.state.mostrarAlerta}>
                  <Alert
                    severity={this.state.severidadAlerta}
                    onClose={this.handleCloseAlert}
                    variant="filled"
                    sx={{ marginTop: 4, width:'100%', borderRadius: '12px' }}
                  >
                    <AlertTitle>
                      {this.state.severidadAlerta.toUpperCase()}
                    </AlertTitle>
                    {this.state.mensajeAlerta}
                  </Alert>
                </Collapse>
              </Snackbar>

              {this.state.mensajeError && (
                <Typography color="error">{this.state.mensajeError}</Typography>
              )}
            </Box>
          </div>

          <div className="login-footer">
            <span>© {año} Selfia. All rights reserved.</span>
          </div>
        </div>
      )
    }

    var contenido = null

    if(this.state.entidad == null) {
      contenido = welcomeBox
    } else {
      contenido = loginBox
    }

    return (
      <Box sx={{display: "flex"}} justifyContent="center">
        {contenido()}
      </Box>
    )
  }
}

export default withTranslation()(LoginPage)
